import { resetArquivoAnexo } from "@/redux/slices/arquivoAnexo/arquivoAnexoSlice";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ArquivoAnexoJsonModel } from "../models/arquivoAnexo/arquivoAnexoJsonModel";
import { ArquivoAnexoModel } from "../models/arquivoAnexo/arquivoAnexoModel";
import { BuscaUrlPreAssinada } from "../models/arquivoAnexo/chamadas/buscaUrlPreAssinada";
import { BuscarContaFinanceiraModel } from "../models/contaFinanceira/chamadas/buscarContaFinanceiraModel";
import { BuscarContaPorIdModel } from "../models/contaFinanceira/chamadas/buscarContaPorIdModel";
import { ListarExportacaoContabilParams } from "../models/contaFinanceira/chamadas/listarExportacaoContabilParams";
import { ExportacaoContabilModel } from "../models/contaFinanceira/exportacaoContabilModel";
import { GerarCalculoRateioModel } from "../models/contaFinanceira/gerarCalculoRateioModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { setModalDeletarContaFinanceira, setPageContaFinanceira } from "../redux/slices/contaFinanceira/contaFinanceiraSlice";
import { setPageLancamentoBancario } from "../redux/slices/lancamentoBancario/lancamentoBancarioSlice";
import api from "../util/api";
import { toastError, toastSucess } from "../util/toast";

export const cadastrarContaFinanceira = createAsyncThunk("/ContaFinanceira/CadastrarContaFinanceira", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const data = await api.post("/ContaFinanceira/CadastrarContaFinanceira", payload.value);
    const idOrigem = data.data.data;

    //anexos
    if (payload.imagens.length !== 0) {
      var arquivoJson: ArquivoAnexoJsonModel[] = [];

      for (const v of payload.imagens) {
        //recuperar url
        let buscaUrl: BuscaUrlPreAssinada = {
          fileName: v.arquivo.name,
          contentType: v.arquivo.type,
        };

        const retorno = await api.get("/ArquivoAnexo/presigned-url", {
          params: { fileName: buscaUrl.fileName, contentType: buscaUrl.contentType },
        });

        const uploadRes = await fetch(retorno.data.data.url, {
          method: "PUT",
          headers: {
            "Content-Type": v.arquivo.type!,
            "x-amz-acl": "public-read",
          },
          body: v.caminhoArquivo,
        });

        if (!uploadRes.ok) {
          toastError("Ocorreu um erro ao fazer o upload do arquivo");
          throw new Error("Erro ao fazer upload para o S3");
        }

        const fileUrl = retorno.data.data.url.split("?")[0];

        var detalhes = {
          caminhoArquivo: fileUrl,
          extensaoArquivo: v.arquivo.type,
          idTipoArquivoAnexo: v.idTipoArquivoAnexo,
          observacao: v.observacao,
          nome: v.arquivo.name,
        };
        arquivoJson.push(detalhes);
      }

      var arquivo: ArquivoAnexoModel = {
        id: null,
        idOrigem: idOrigem,
        caminhoArquivo: null,
        extensaoArquivo: null,
        idTipoArquivoAnexo: null,
        observacao: null,
        nome: null,
        arquivoAnexo: arquivoJson,
        containerName: "contafinanceira",
        dataCriacao: null,
        idUsuario: null,
      };

      await api.post("/ArquivoAnexo/CadastrarArquivoAnexo", arquivo);

      toastSucess("A conta financeira e os anexos foram cadastrados com sucesso");
      dispatch(resetArquivoAnexo());
    } else {
      toastSucess("Conta financeira cadastrada com sucesso");
    }
    dispatch(payload.origem === "contaFinanceira" ? setPageContaFinanceira("geral") : setPageLancamentoBancario("geral"));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const duplicarContaFinanceira = createAsyncThunk("/ContaFinanceira/DuplicarContaFinanceira", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/ContaFinanceira/DuplicarContaFinanceira", payload.value);
    toastSucess("Conta financeira duplicada com sucesso");
    dispatch(payload.origem === "contaFinanceira" ? setPageContaFinanceira("geral") : setPageLancamentoBancario("geral"));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const aplicarRateioContaFinanceira = createAsyncThunk("/ContaFinanceira/AplicarRateioContaFinanceira", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/ContaFinanceira/AplicarRateioContaFinanceira", payload.value);
    toastSucess("Rateio da conta financeira atualizado com sucesso");
    dispatch(setPageContaFinanceira("geral"));
    dispatch(setLoading(false));

    dispatch(listarRateioContaFinanceira(payload.buscaRateio));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const cancelarContaFinanceira = createAsyncThunk("/ContaFinanceira/CancelarContaFinanceira", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/ContaFinanceira/CancelarContaFinanceira", null, {
      params: { idContaFinanceira: payload.value },
    });
    toastSucess("Conta financeira cancelada com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarContaFinanceira(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const modificarSituacaoContaFinanceira = createAsyncThunk("/ContaFinanceira/ModificarSituacaoContaFinanceira", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/ContaFinanceira/ModificarSituacaoContaFinanceira", payload.value);
    toastSucess("As situações das contas financeiras com saldo foram alteradas com sucesso");
    dispatch(setLoading(false));

    dispatch(listaContaFinanceiraSorteioComSaldo(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarContaFinanceira = createAsyncThunk("/ContaFinanceira/BuscarContaFinanceira", async (args: BuscarContaFinanceiraModel) => {
  try {
    const data = await api.post("/ContaFinanceira/BuscarContaFinanceira", args);
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const recuperarContaFinanceira = createAsyncThunk("/ContaFinanceira/RecuperarContaFinanceira", async (id: number) => {
  try {
    const data = await api.get("/ContaFinanceira/RecuperarContaFinanceira", {
      params: { id: id },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarRateioContaFinanceira = createAsyncThunk("/ContaFinanceira/ListarRateioContaFinanceira", async (idContaFinanceira: number) => {
  try {
    const data = await api.get("/ContaFinanceira/ListarRateioContaFinanceira", { params: { idContaFinanceira: idContaFinanceira } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarSituacaoContaFinanceira = createAsyncThunk("/ContaFinanceira/ListarSituacaoContaFinanceira", async () => {
  try {
    const data = await api.get("/ContaFinanceira/ListarSituacaoContaFinanceira");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarDetalheContaFinanceira = createAsyncThunk("/ContaFinanceira/ListarDetalheContaFinanceira", async (idConta: number) => {
  try {
    const data = await api.get("/ContaFinanceira/ListarDetalheContaFinanceira", { params: { idConta: idConta } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarExportacaoContabil = createAsyncThunk("/ContaFinanceira/ListarExportacaoContabil", async (params: ListarExportacaoContabilParams) => {
  try {
    const data = await api.get("/ContaFinanceira/ListarExportacaoContabil", {
      params: {
        dataInicio: params.dataInicio,
        dataFim: params.dataFim,
        idEmpresa: params.idEmpresa,
        jsonFiltroAvancado: params.jsonFiltroAvancado ?? null,
      },
    });
    return data.data.data as ExportacaoContabilModel[];
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarHistoricoContaFinanceira = createAsyncThunk("/ContaFinanceira/ListarHistoricoContaFinanceira", async (idContaFinanceira: number) => {
  try {
    const data = await api.get("/ContaFinanceira/ListarHistoricoContaFinanceira", { params: { idContaFinanceira: idContaFinanceira } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const gerarCalculoRateio = createAsyncThunk("/ContaFinanceira/GerarCalculoRateio", async (args: GerarCalculoRateioModel) => {
  try {
    const data = await api.get("/ContaFinanceira/GerarCalculoRateio", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarPlanosContaFinanceiro = createAsyncThunk("/ContaFinanceira/ListarPlanosContaFinanceiro", async () => {
  try {
    const data = await api.get("/ContaFinanceira/ListarPlanosContaFinanceiro");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listaContaFinanceiraSorteioComSaldo = createAsyncThunk("/ContaFinanceira/ListaContaFinanceiraSorteioComSaldo", async (idSorteio: number) => {
  try {
    const data = await api.get("/ContaFinanceira/ListaContaFinanceiraSorteioComSaldo", { params: { idSorteio: idSorteio } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listaUltimoHistoricoFornecedor = createAsyncThunk("/ContaFinanceira/ListaUltimoHistoricoFornecedor", async (params: { idPessoa: number; idEmpresa?: number | null }) => {
  try {
    const data = await api.get("/ContaFinanceira/ListaUltimoHistoricoFornecedor", { params: { idPessoa: params.idPessoa, idEmpresa: params.idEmpresa } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarContaFinanceiraPorId = createAsyncThunk("/ContaFinanceira/BuscarContaFinanceiraPorId", async (parametros: BuscarContaPorIdModel) => {
  try {
    const data = await api.get("/ContaFinanceira/BuscarContaFinanceiraPorId", { params: { id: parametros.id, pagamentoRecebimento: parametros.pagamentoRecebimento } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarContaFinanceira = createAsyncThunk("/ContaFinanceira/AtualizarContaFinanceira", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/ContaFinanceira/AtualizarContaFinanceira", payload.value);
    toastSucess("Conta financeira atualizada com sucesso");
    dispatch(payload.origem === "contaFinanceira" ? setPageContaFinanceira("geral") : setPageLancamentoBancario("geral"));

    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarContaFinanceira = createAsyncThunk("/ContaFinanceira/DeletarContaFinanceira", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/ContaFinanceira/DeletarContaFinanceira", {
      params: { id: payload.value },
    });
    toastSucess("Conta financeira removida com sucesso");
    dispatch(setModalDeletarContaFinanceira(false));
    dispatch(setLoading(false));

    dispatch(buscarContaFinanceira(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
